// extracted by mini-css-extract-plugin
module.exports = {"collapsed2":"navbarkids_collapsed2__WpssW","collapsed1":"navbarkids_collapsed1__rPIik","loader":"navbarkids_loader__3SSYq","loader1":"navbarkids_loader1__2PNzH"};